import { type ListingFiltersDto } from '~/apiClient';

type SavedSearchLabelsSource = Readonly<{
    filters: ListingFiltersDto;
    brandNames: readonly string[];
    modelName?: string;
}>;

type UseSavedSearchLabelsReturn = {
    getSavedSearchLabels: (source: SavedSearchLabelsSource) => string[];
};

/** The chips of a saved search, written as the SLP writes them, away from the SLP: brand, model and class first. */
export const useSavedSearchLabels = (): UseSavedSearchLabelsReturn => {
    // COMPOSABLES
    const { getFeatureLabel, getEnumLabel, getPlatformClassLabel, getCountryLabel, getRangeLabel, getQueryLabel } = useSlpFilterLabels();

    return {
        getSavedSearchLabels: ({ filters, brandNames, modelName }) => [
            ...brandNames,
            ...(modelName ? [modelName] : []),
            ...filters.platformClass.map(getPlatformClassLabel),
            ...SLP_ENUM_FILTER_KEYS.filter(key => key !== 'platformClass').flatMap(key => filters[key].map(value => getEnumLabel(key, value))),
            ...SLP_VALUE_FILTER_KEYS.flatMap(key => filters[key].map(String)),
            ...SLP_COUNTRY_FILTER_KEYS.flatMap(key => filters[key].map(getCountryLabel)),
            ...filters.features.map(getFeatureLabel),
            ...SLP_RANGE_FILTER_KEYS.flatMap(key => {
                const from = filters[`${key}From`];
                const to = filters[`${key}To`];

                return [
                    ...(from !== undefined ? [getRangeLabel(key, 'from', from)] : []),
                    ...(to !== undefined ? [getRangeLabel(key, 'to', to)] : []),
                ];
            }),
            ...(filters.q ? [getQueryLabel(filters.q)] : []),
        ],
    };
};
